import { render, staticRenderFns } from "./NewLicencesSetup.vue?vue&type=template&id=412a0d3a&"
import script from "./NewLicencesSetup.vue?vue&type=script&lang=js&"
export * from "./NewLicencesSetup.vue?vue&type=script&lang=js&"
import style0 from "./NewLicencesSetup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('412a0d3a')) {
      api.createRecord('412a0d3a', component.options)
    } else {
      api.reload('412a0d3a', component.options)
    }
    module.hot.accept("./NewLicencesSetup.vue?vue&type=template&id=412a0d3a&", function () {
      api.rerender('412a0d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/LicenceSetup/NewLicencesSetup.vue"
export default component.exports